import BaseProxy from './BaseProxy';

class Notification extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/notifications', parameters);
    }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/api/Notifications.js